import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusXeActionTypeIds, IBusXeActionTypes } from "../../action-types/bus/IBusXeActionTypes";
import { IBusXePageStateModel } from "../../page-state-model/bus/IBusXePageState";

const initialState: IBusXePageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_xes: [],
	bus_xe_editing: undefined,
	bus_xe_deleting: undefined,
	bus_xe_selected_ids: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false
}

export const busXeReducer = (state: IBusXePageStateModel = initialState, action: IBusXeActionTypes): IBusXePageStateModel => {
	switch (action.type) {
		case eBusXeActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusXeActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_xes: action.payload || []
			}
		case eBusXeActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_xes: []
			}
		case eBusXeActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				bus_xe_editing: action.payload
			}
		case eBusXeActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				bus_xe_editing: undefined
			}
		case eBusXeActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				bus_xe_selected_ids: action.payload
			}
		case eBusXeActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true,
				bus_xe_deleting: action.payload
			}
		case eBusXeActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false,
				bus_xe_deleting: undefined
			}
		case eBusXeActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusXeActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				bus_xe_deleting: undefined
			}
		case eBusXeActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eBusXeActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusXeActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Thay đổi dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				bus_xe_editing: undefined
			}
		case eBusXeActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
